import { RootState, VSCAssetImageSourceName } from 'js/types';

import { useTypedSelector } from './typedUseSelector';

export const getUserImageLibrary = (state: RootState, imageType: VSCAssetImageSourceName) =>
  state.images.userLibrary[imageType];

export const useUserImageLibrary = (imageType: VSCAssetImageSourceName) =>
  useTypedSelector(state => getUserImageLibrary(state, imageType));
